import React from 'react';
import { Box, Typography } from '@mui/material';
import aboutWhatDataED3NCollects from '../../../config/AboutWhatDataED3NCollects';

const AboutWhatDataED3NCollects = () => {
    const { title, content, lastUpdated } = aboutWhatDataED3NCollects;

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 300 }}>
            <Typography variant="h2" style={{ fontSize: '2.5rem' }}>
                {title}
            </Typography>
            <Box mt={2}>
                <Typography variant="body1" style={{ fontSize: '1rem' }}>
                    {content}
                </Typography>
            </Box>
            <Box sx={{ flexGrow: 1 }} />
            <Box display="flex" justifyContent="flex-end">
                <Typography variant="caption" color="text.secondary">
                    Last Updated: {lastUpdated}
                </Typography>
            </Box>
        </Box>
    );
};

export default AboutWhatDataED3NCollects;